import { Component, OnDestroy, ChangeDetectionStrategy, Input, OnInit, ChangeDetectorRef, ViewChild, TemplateRef, Optional } from '@angular/core';
import { NbThemeService, NbWindowRef, NbWindowService } from '@nebular/theme';
import { takeWhile } from 'rxjs/operators';
import { AuthenticationService } from '../../authentication/authentication.service';
import { NbMenuService, NbSidebarService } from '@nebular/theme';
import { Router } from '@angular/router';
import { CommonService } from "@services/common.service";

interface UploadedImage {
  base64Data: string;
  file: File;
  fileName: string;
}

// TODO: move layouts into the framework
@Component({
  selector: 'app-layout',
  changeDetection: ChangeDetectionStrategy.Default,
  styleUrls: ['./layout.component.scss'],
  templateUrl: './layout.component.html'
})
export class LayoutComponent implements OnDestroy, OnInit {
  @ViewChild('popupTemplate') popupTemplate: TemplateRef<any>;

  private alive = true;

  currentTheme: string;
  menuAction = [];
  menuSetting = [];
  onAction = true;
  onSettings = false;
  feedback = {
    summary: '',
    description: '',
    type: 'Feedback',
    name: '',
    email: '',
    files: []
  };
  selectedFile: File | null = null;  
  uploadedImages: UploadedImage[] = [];
  isSubmit = false;
  showErrorSummary = false;
  showErrorEmail = false;

  constructor(
    protected themeService: NbThemeService,
    @Optional() protected windowRef: NbWindowRef,
    private authenticationService: AuthenticationService,
    private menuService: NbMenuService,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private windowService: NbWindowService,
    private common: CommonService
  ) {
    this.themeService.getJsTheme()
      .pipe(takeWhile(() => this.alive))
      .subscribe(theme => {
        this.currentTheme = theme.name;
    });

    // this.menuService.onSubmenuToggle().subscribe(obs => {
    //   if (obs.item.expanded) {
    //    obs.item.subMenuHeight = (obs.item.children.length * 40); 
    //   }
    //  });
  }

  ngOnInit() {
    // get list from side menu
    const menuList = this.authenticationService.getMenuList();

    if (menuList) {
      for (let menu of menuList) {
        for (let submenu of (menu.children ? menu.children : [])) {
          if (submenu.ATgroup == 'Actions') {
            if (this.router.url === submenu.link) {
              submenu.active = true;
              this.onAction = true;
              this.onSettings = false;
            }

            this.menuAction.push(submenu);
          }
          if (submenu.ATgroup == 'Databases') {
            if (this.router.url === submenu.link) {
              submenu.active = true;
              this.onAction = false;
              this.onSettings = true;
            }
            this.menuSetting.push(submenu);
          }
        }
      }
    }
  }

  ngOnDestroy() {
    this.alive = false;
  }

  openWindow() {
    this.windowRef = this.windowService.open(this.popupTemplate, { title: `Provide Feedback`, windowClass: 'feedback-form' });

  }

  closeFeedback() {
    this.windowRef.close();
  }

  submitFeedback() {
    this.isSubmit = true;
    if (this.feedback.email != '' && this.feedback.summary != '') {
      this.showErrorSummary = false;
      this.showErrorEmail = false;
      
      this.windowRef.close();
      if (this.uploadedImages.length > 0) {
        this.feedback.files = this.uploadedImages;
      }
      // call monday feedback api
      this.common.submitFeedback(this.feedback).subscribe(() => {
        this.feedback = {
          summary: '',
          description: '',
          type: 'Feedback',
          name: '',
          email: '',
          files: []
        };

        this.uploadedImages = [];
      });

    } else {
      if (this.feedback.summary == '') this.showErrorSummary = true;
        else this.showErrorSummary = false;
      if (this.feedback.email == '') this.showErrorEmail = true;
        else this.showErrorEmail = false;
    }
  }

  isClientRoute() {
    if (this.router.url.includes('/client/')) return true;
    return false;
  }

  goToPage(page) {

    this.router.navigate([page.link], { replaceUrl: true });

  }

  handleFileInput(event: any): void {
    this.selectedFile = event.target.files[0];

    if (this.selectedFile) {
      const reader = new FileReader();

      reader.onload = (e: any) => {
        const base64Image = e.target.result;
        this.uploadedImages.push({ base64Data: base64Image, file: this.selectedFile, fileName: this.selectedFile.name });
        this.selectedFile = null; // Clear the selected file after uploading
      };

      reader.readAsDataURL(this.selectedFile);
    }
  }

  uploadImages(): void {
    this.uploadedImages.forEach((img) => {
      // You can send each base64 data to the server if needed
      console.log('Base64 image data:', img.base64Data);
    });
  }

  removeImage(index: number): void {
    this.uploadedImages.splice(index, 1);
  }
}
